<template>
  <div class="hall review-hall-layout">
    <div class="layout-header">
      <div class="hall-title">{{ hallTitle }}</div>
      <div v-if="showRouteStep" class="route-step">
        <step-tabs
          v-model="currentIndex"
          :tab-list="processTab"
          reverse-color
          :before-change="beforeStepChange"
        />
      </div>
    </div>
    <div class="layout-body">
      <router-view />
    </div>
  </div>
</template>

<script>
import StepTabs from '@/views/hall/review-hall/components/StepTabs'
import { mapGetters, mapState } from 'vuex'
import { workbenchServiceDict } from '@/dictionary/system'

export default {
  name: 'ReviewHallLayout',

  components: {
    StepTabs
  },

  data() {
    return {
      // 大厅标题
      hallTitle: '精彩纵横评审工作台',

      currentIndex: 0
    }
  },

  computed: {
    ...mapState('reviewHall', ['project', 'processList', 'reviewWayList']),
    ...mapGetters('reviewHall', ['processTab']),
    ...mapState('router', ['currentWorkbench']),

    projectId() {
      return Number(this.$route.params.projectId || 0)
    },

    bidderId() {
      return Number(this.$route.params.bidderId || 0)
    },

    showRouteStep() {
      return !this.bidderId
    },

    // 是否是代理机构操作
    isAgency() {
      return this.currentWorkbench === workbenchServiceDict.AGENCY.value
    }
  },

  created() {
    this.$store.commit('reviewHall/SET_PROJECT_ID', this.projectId)
    if (this.bidderId) return

    if (this.$route.name.includes('ReviewSession')) {
      this.currentIndex = 1
    }

    if (this.$route.name.includes('ReviewReport')) {
      this.currentIndex = 2
    }
  },

  methods: {
    beforeStepChange(index) {
      const tab = this.processTab[index]
      if (!tab.active) {
        this.$message({
          message: '尚未开始',
          offset: 64,
          showClose: true
        })
        return false
      }

      const firstReviewWay = this.project.wayList[0]
      this.$router.push({
        name: this.isAgency ? 'Agency' + tab.routeName : tab.routeName,
        params: {
          wayId: firstReviewWay.wayId
        }
      })
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.hall {
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.review-hall-layout {
  .layout-header {
    width: 100%;
    height: 64px;
    background: $primary-color;
    color: $white-color;
    display: flex;
    align-items: center;
    overflow: hidden;
    box-sizing: border-box;
    padding: 12px 32px;
    position: fixed;
    z-index: 999;

    .hall-title {
      font-size: 20px;
    }
  }

  .layout-body {
    margin-top: 64px;
    flex: 1;
    box-sizing: border-box;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
  }

  .route-step {
    width: 100%;
    height: 64px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
}
</style>
